<ng-container *ngIf="dialog$ | async as dialog">
  <div class="paybee-modal-header">
    <div class="modal-title">{{ dialog.initialState.modalTitle || "Confirm Bid Amount?" }}</div>
  </div>
  <div class="modal-body">
    <div class="text-center modal-text" [innerHTML]="dialog.initialState.modalText"></div>
  </div>
  <div class="modal-footer paybee-modal-footer">
    <div class="row">
      <div class="col-4 offset-4">
        <button type="button" class="btn btn--paybee btn--cancel btn--md text-center w-100" (click)="close(dialog, false)">{{ dialog.initialState.buttonCancel || "No" }}</button>
      </div>
      <div class="col-4">
        <button type="button" class="btn btn--paybee btn--success btn--md text-center w-100" (click)="close(dialog, true)">{{ dialog.initialState.buttonConfirm || "Yes" }}</button>
      </div>
    </div>
  </div>
</ng-container>
